import React from 'react';
import { useDashboardStats } from '../../hooks/useAdmin';
import { UsersIcon, BuildingIcon, ClockIcon, BriefcaseIcon, FileTextIcon, CheckCircleIcon, AlertCircleIcon, SettingsIcon } from '../../components/common/Icons';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const { data: stats, isLoading } = useDashboardStats();

  if (isLoading) {
    return (
      <div className="admin-dashboard">
        <div className="admin-dashboard__loading">
          <div className="admin-dashboard__spinner"></div>
          <p>Loading dashboard data...</p>
        </div>
      </div>
    );
  }

  const statCards = [
    {
      title: 'Total Employees',
      value: stats?.total_employees || 0,
      icon: UsersIcon,
      color: 'var(--primary-color)',
      bgGradient: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)'
    },
    {
      title: 'Total Employers',
      value: stats?.total_employers || 0,
      icon: BuildingIcon,
      color: 'var(--success-color)',
      bgGradient: 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
    },
    {
      title: 'Pending Verifications',
      value: stats?.pending_verifications || 0,
      icon: ClockIcon,
      color: 'var(--warning-color)',
      bgGradient: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)'
    },
    {
      title: 'Total Jobs',
      value: stats?.total_jobs || 0,
      icon: BriefcaseIcon,
      color: '#8b5cf6',
      bgGradient: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)'
    },
    {
      title: 'Pending Jobs',
      value: stats?.pending_jobs || 0,
      icon: AlertCircleIcon,
      color: 'var(--error-color)',
      bgGradient: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)'
    },
    {
      title: 'Completed Jobs',
      value: stats?.completed_jobs || 0,
      icon: CheckCircleIcon,
      color: 'var(--turquoise)',
      bgGradient: 'linear-gradient(135deg, #20b2aa 0%, #008b8b 100%)'
    },
    {
      title: 'Job Roles',
      value: stats?.total_job_roles || 0,
      icon: SettingsIcon,
      color: '#ec4899',
      bgGradient: 'linear-gradient(135deg, #ec4899 0%, #db2777 100%)'
    }
  ];

  const IconComponent = ({ Icon, gradient }) => (
    <div className="admin-dashboard__stat-icon" style={{ background: gradient }}>
      <Icon className="admin-dashboard__icon-svg" size={28} />
    </div>
  );

  return (
    <div className="admin-dashboard">
      <div className="admin-dashboard__header">
        <div>
          <h1 className="admin-dashboard__title">Dashboard Overview</h1>
          <p className="admin-dashboard__subtitle">Monitor and manage your platform at a glance</p>
        </div>
      </div>

      <div className="admin-dashboard__stats">
        {statCards.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <div key={index} className="admin-dashboard__stat-card">
              <IconComponent Icon={Icon} gradient={stat.bgGradient} />
              <div className="admin-dashboard__stat-content">
                <p className="admin-dashboard__stat-title">{stat.title}</p>
                <h3 className="admin-dashboard__stat-value">{stat.value.toLocaleString()}</h3>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AdminDashboard;

